import { useState, useMemo, useCallback } from 'react';
import { useLegalEntityInfiniteList } from 'src/use-cases/settings/useLegalEntityInfiniteList';
import { SearchableSelect, SearchableSelectOption } from '../SearchableSelect';
import { CreateEntityModal } from './CreateConsigneeModal';

interface LegalEntitySelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder: string;
  addNewLabel: string;
  modalTitle: string;
  addressType: 'PICK_UP' | 'DELIVERY';
}

export const LegalEntitySelector = ({ value, onChange, placeholder, addNewLabel, modalTitle, addressType }: LegalEntitySelectorProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search, setSearch] = useState('');

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } = useLegalEntityInfiniteList({ search });

  const EMPTY_OPTION: SearchableSelectOption = { value: '', label: 'Empty' };

  const options: SearchableSelectOption[] = useMemo(() => {
    const entityOptions =
      data?.pages?.flatMap(
        (page) =>
          page?.data?.content?.map((entity) => ({
            value: entity.code,
            label: `${entity.code} (${entity.name})`,
          })) ?? []
      ) ?? [];
    return [EMPTY_OPTION, ...entityOptions];
  }, [data]);

  const handleSearchChange = useCallback((val: string) => {
    setSearch(val);
  }, []);

  const handleCreateSuccess = (newEntity: any) => {
    if (newEntity?.code) {
      onChange?.(newEntity.code);
    }
  };

  return (
    <>
      <SearchableSelect
        options={options}
        value={value}
        onChange={onChange}
        onAddNew={() => setIsModalOpen(true)}
        placeholder={placeholder}
        addNewLabel={addNewLabel}
        onSearchChange={handleSearchChange}
        onLoadMore={() => fetchNextPage()}
        hasNextPage={!!hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
      />
      <CreateEntityModal open={isModalOpen} setOpen={setIsModalOpen} onSuccess={handleCreateSuccess} title={modalTitle} addressType={addressType} />
    </>
  );
};
